import { ResponsiveHeading } from './pageHeading.style';
import type { PageHeadingProps } from '../../types';

/**
 * ResponsivePageHeading
 *
 * Responsive variant of `PageHeading`. Font sizes adapt per breakpoint via
 * `RESPONSIVE_HEADING_SIZES` from the sales-checkin-components constants,
 * which derives every value from the ui-bricks typography scale — no
 * hardcoded values anywhere:
 *   • Desktop  (default)  →  RESPONSIVE_HEADING_SIZES[level].desktop  (30px for level 2)
 *   • Tablet   ≤ 1279px   →  RESPONSIVE_HEADING_SIZES[level].tablet   (28px for level 2)
 *   • Mobile   ≤  767px   →  RESPONSIVE_HEADING_SIZES[level].mobile   (24px for level 2)
 */
export const ResponsivePageHeading = ({ children, 'data-testid': dataTestId = 'page-heading' }: PageHeadingProps) => (
    <ResponsiveHeading level={2} weight="bold" data-testid={dataTestId}>
        {children}
    </ResponsiveHeading>
);

export default ResponsivePageHeading;
